import { obterLocaisAsync } from "../../services/localService";

const atualizarLocais = async ({ commit }) => {
    const locais = await obterLocaisAsync();
    commit('atualizarLocais', locais);
}

const atualizarLocal = ({ commit }, local) => {
    commit('atualizarLocal', local);
}

const addLocal = ({ commit }, local) => {
    commit('addLocal', local);
}

const updateLocal = ({ commit }, local) => {
    commit('updateLocal', local);
}

export default {
    atualizarLocais,
    atualizarLocal,
    addLocal,
    updateLocal
}
